import { useState, useEffect } from 'react'
import { getIncomeLangFeeTypeAPI } from '../services/in-come'

function UseIncomeLangFeeType() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getIncomeLangFeeTypeAPI()
      if (!resp) return
      if (resp.status) {
        setData(
          resp.result.map((d) => ({ label: d.langFee, value: d.langFeeId }))
        )
      }
    }
    getData()
  }, [])

  return data
}

export default UseIncomeLangFeeType
